import classNames from 'classnames';
import { FC } from 'react';
import { COLORS } from 'src/constants/styles';
import './style.scss';

export type TLabelTheme = COLORS.GRAY | COLORS.RED | COLORS.MAINBLUE | COLORS.GREEN | COLORS.YELLOW | COLORS.WHITE;
interface IProps {
  text?: string;
  color?: TLabelTheme;
  className?: string;
}

const Label: FC<IProps> = ({ text, color = COLORS.GRAY, className }: IProps): JSX.Element => {
  return <div className={classNames('label letter-spacing-12', `label-${color}`, className)}>{text}</div>;
};

export default Label;
